import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";

/**
 * Wrap a route element to require authentication.
 * - user === undefined  → checking, render a lightweight placeholder.
 * - user === null       → redirect to /login?next=<current>.
 * - user object         → render children.
 */
const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (user === undefined) {
    return (
      <div data-testid="auth-loading" className="dl-container py-20 text-[#4B5563] text-sm">
        Checking session…
      </div>
    );
  }
  if (user === null) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  return children;
};

export default ProtectedRoute;
